import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { CustomHandler } from "@thos/Store/CustomHandlerCreator";
import setReorderSelectedList from "@thos/Store/Data/OrderHistory/Handlers/SetReorderSelectedList";

type HandlerType = CustomHandler<{ allChecked: boolean }>;

export const SetAllSelectedForAddToList: HandlerType = props => {
    if (props.parameter.allChecked) {
        const state = props.getState();
        const order = getOrderState(state, state.pages.orderDetails.orderNumber);
        if (!order.value) {
            throw new Error("Selected Reorder was called but there was no order available");
        }

        const selectedLineItems: string[] = [];

        order.value.orderLines?.forEach(line => {
            selectedLineItems.push(line.id)
        })
        props.dispatch(
            setReorderSelectedList({
                cartlistSelectedArray: selectedLineItems,
            })
        );
    }
    else {
        props.dispatch(
            setReorderSelectedList({
                cartlistSelectedArray: [],
            })
        );
    }
};

export const chain = [
    SetAllSelectedForAddToList
];

const setAllSelectedToAddToList = createHandlerChainRunner(chain, "setAllSelectedToAddToList");
export default setAllSelectedToAddToList;
